export default __webpack_public_path__ + "static/media/website-info2.3eabbaeb.png";